@use '../../design-tokens/breakpoints/breakpoints' as *;

@layer design-system {
  .logo {
    width: 103px;
  }

  .logoMini {
    height: 20px;
    width: 30px;
    position: absolute;
    left: 39px;
    top: 0;
    opacity: 0;
  }

  .root {
    position: relative;
    min-width: 50px;
    height: 20px;

    .logo {
      display: none;
      opacity: 0;

      img {
        width: 50px;
      }

      @include respond-to('xl') {
        opacity: 1;
        display: block;
      }
    }

    .logoMini {
      opacity: 1;

      @include respond-to('xl') {
        opacity: 0;
      }
    }
  }
}
